import lottieLoading from "../../../../assets/svg/lottie_loading.json";
import Lottie from "lottie-react";
import SwipableViews from "../../../../components/SwipableViews";
import PaymentGraphics from "../PaymentGraphics/PaymentGraphics";
import React from "react";
import { HeroGraphics1Container, LottiHolder } from "./HeroGraphics1.styled";

const HeroGraphics1 = () => {
  const [index, setIndex] = React.useState(0);

  const handleChangeIndex = (index: number) => {
    setIndex(index);
  };
  return (
    <HeroGraphics1Container>
      <SwipableViews>
        <LottiHolder>
          <Lottie loop={true} animationData={lottieLoading} />
        </LottiHolder>
        <PaymentGraphics />
      </SwipableViews>
    </HeroGraphics1Container>
  );
};

export default HeroGraphics1;
